import React, { useEffect, useState } from "react";
import MiniDrawer from "../../components/Drawer/MiniDrawer";
import { useDispatch, useSelector } from "react-redux";
import { fetchOverdueData } from "../../redux/slices/overdueSlice";
import { fetchOverdueDataPawn } from "../../redux/slices/overuePawn";

const MainLayout = () => {
  const dispatch = useDispatch();

  const overdueData = useSelector((state) => state.overdue.data || undefined);
  const overduePawn = useSelector(
    (state) => state.overduePawn.data || undefined
  );

  const [isLoading, setIsLoading] = useState(true);
  const [retryCount, setRetryCount] = useState(0);
  const MAX_RETRIES = 5;

  useEffect(() => {
    dispatch(fetchOverdueData());
    dispatch(fetchOverdueDataPawn());
  }, [dispatch, retryCount]);

  useEffect(() => {
    console.log("overdueData:", overdueData);
    console.log("overduePawn:", overduePawn);
    console.log("Retry Count:", retryCount);

    if (
      overdueData !== undefined &&
      overduePawn !== undefined &&
      (overdueData.length > 0 || overduePawn.length > 0) // อัปเดตเงื่อนไข
    ) {
      console.log("Data loaded successfully!");
      setIsLoading(false); // ปิด Loading
    } else if (retryCount < MAX_RETRIES) {
      console.log("Data incomplete, retrying...");
      const timeout = setTimeout(() => {
        setRetryCount((prev) => prev + 1); // เพิ่ม retry count
      }, 2000);

      return () => clearTimeout(timeout); // Clear timeout
    } else {
      console.error("Failed to load data after maximum retries");
      setIsLoading(false); // แม้จะไม่มีข้อมูลก็ปิด Loading
    }
  }, [overdueData, overduePawn, retryCount]);
  // console.log("overdueData123", overdueData);

  // if (isLoading) {
  //   return (
  //     <div
  //       style={{
  //         display: "flex",
  //         justifyContent: "center",
  //         alignItems: "center",
  //         height: "100vh",
  //         backgroundColor: "#F8F7FD",
  //       }}
  //     >
  //       <p>Loading...</p>
  //     </div>
  //   );
  // }

  return (
    <div
      style={{
        backgroundColor: "#F8F7FD",
        minHeight: "100vh",
        width: "100%",
        minWidth: "500px",
      }}
    >
      <MiniDrawer overdueData={overdueData} overduePawn={overduePawn} />
    </div>
  );
};

export default MainLayout;
